import * as actionTypes from "./actionTypes";
import API from "../../axios/api";
import axios from "axios";
import { isEqual } from 'lodash';
import filterObjectToQuery from '../../utils/filterObjectToQuery';

let CancelToken = axios.CancelToken;
let fetchLogsSuperadmin_cancel;
let fetchLogsSuperadminById_cancel;
let fetchLogsSuperadminOptionsTenants_cancel;

export const requestLogsSuperadminStart = () => {
  return {
    type: actionTypes.REQUEST_LOGS_SUPERADMIN_START,
  };
};

export const requestLogsSuperadminByIdStart = () => {
  return {
    type: actionTypes.REQUEST_LOGS_SUPERADMIN_BY_ID_START,
  };
};

export const fetchLogsSuperadminSuccess = (logs) => {
  return {
    type: actionTypes.FETCH_LOGS_SUPERADMIN_SUCCESS,
    logs,
  };
};

export const setLogsSuperadminFilter = (page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds, filteredTenants) => {
  return {
    type: actionTypes.SET_LOGS_SUPERADMIN_FILTER,
    logsFilter: {
      page,
      limit,
      search,
      order,
      orderBy,
      startDate,
      endDate,
      filteredUsers,
      filteredTypes,
      filteredOperationsName,
      filteredTables,
      filteredDocumentsIds,
      filteredTenants
    },
  };
};

export const clearLogsSuperadminFilter = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, null, null, [], [], [], [], [], []));
  }
}

export const triggerRemoveLogsSuperadminStartDateFilter = (page, limit, search, order, orderBy, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants) => {
  return dispatch => {
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, null, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants))
  }
};

export const triggerRemoveLogsSuperadminEndDateFilter = (page, limit, search, order, orderBy, filteredStartDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants) => {
  return dispatch => {
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, null, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants))
  }
};

export const triggerRemoveLogsSuperadminUsersFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants, user) => {
  return dispatch => {
    let aux = [...selectedUsers];
    const newFilteredUsers = aux.filter((el) => el.value !== user.value);
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, newFilteredUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants));
  }
};

export const triggerRemoveLogsSuperadminTypesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants, type) => {
  return dispatch => {
    let aux = [...selectedTypes];
    const newFilteredTypes = aux.filter((el) => el.value !== type.value);
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, newFilteredTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants));
  }
};

export const triggerRemoveLogsSuperadminOperationsNameFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants, operationName) => {
  return dispatch => {
    let aux = [...selectedOperationsName];
    const newFilteredOperationsName = aux.filter((el) => el.value !== operationName.value);
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, newFilteredOperationsName, selectedTables, filteredDocumentsIds, filteredTenants));
  }
};

export const triggerRemoveLogsSuperadminTablesFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants, table) => {
  return dispatch => {
    let aux = [...selectedTables];
    const newFilteredTables = aux.filter((el) => el.value !== table.value);
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, newFilteredTables, filteredDocumentsIds, filteredTenants));
  }
};

export const triggerRemoveLogsSuperadminDocumentsIdsFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredDocumentsIds, filteredTenants, docId) => {
  return dispatch => {
    let aux = [...filteredDocumentsIds];
    const newFilteredDocumentIds = aux.filter((el) => el !== docId);
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, newFilteredDocumentIds, filteredTenants));
  }
};

export const triggerRemoveLogsSuperadminTenantsFilter = (page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, filteredTenants, docId) => {
  return dispatch => {
    let aux = [...filteredTenants];
    const newFilteredTenants = aux.filter((el) => el !== docId);
    dispatch(fetchLogsSuperadmin(page, limit, search, order, orderBy, filteredStartDate, filteredEndDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, newFilteredTenants));
  }
};

export const fetchLogsSuperadmin = (
  page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds, filteredTenants
) => {
  fetchLogsSuperadmin_cancel && fetchLogsSuperadmin_cancel();
  return (dispatch) => {
    
    dispatch(setLogsSuperadminFilter(page, limit, search, order, orderBy, startDate, endDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, filteredDocumentsIds, filteredTenants));
    dispatch(requestLogsSuperadminStart());
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${
      !limit || limit < 25 ? limit : limit
    }&q=${search ? search : ''}&sort=${order === "desc" ? "-" : ""}${orderBy}`;
    queryParams += `${startDate ? `&start_date=${startDate.toISOString()}` : ''}`;
    queryParams += `${endDate  ? `&end_date=${endDate.toISOString()}` : ''}`;
    queryParams += `${filteredUsers && filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filteredUsers)}` : ''}`;
    queryParams += `${filteredTypes && filteredTypes.length > 0 ? `&types=${filterObjectToQuery(filteredTypes)}` : ''}`;
    queryParams += `${filteredOperationsName && filteredOperationsName.length > 0 ? `&operationsName=${filterObjectToQuery(filteredOperationsName)}` : ''}`;
    queryParams += `${filteredTables && filteredTables.length > 0 ? `&tables=${filterObjectToQuery(filteredTables)}` : ''}`;
    queryParams += `${filteredDocumentsIds && filteredDocumentsIds.length > 0 ? `&docs_ids=${filteredDocumentsIds.join(',')}` : ''}`;
    queryParams += `${filteredTenants && filteredTenants.length > 0 ? `&tenants=${filterObjectToQuery(filteredTenants)}` : ''}`;

    API.get("/logs/superadmin" + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchLogsSuperadmin_cancel = c;
      }),
    }).then((res) => {
      dispatch(fetchLogsSuperadminSuccess(res.data));
    })
    .catch(err => {
      console.log(err)
    });
  };
};

export const fetchLogsSuperadminById = (id) => {
  fetchLogsSuperadminById_cancel && fetchLogsSuperadminById_cancel();

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(requestLogsSuperadminByIdStart());
      API.get("/logs/superadmin/" + id, {
        cancelToken: new CancelToken(function executor(c) {
          fetchLogsSuperadminById_cancel = c;
        }),
      })
        .then((res) => {
          dispatch(fetchLogsSuperadminByIdSuccess(res.data));
          resolve("success");
        })
        .catch((err) => {
          /* dispatch(requestEmployeesFail(err)); */
          reject("error");
        });
    });
  };
};

export const fetchLogsSuperadminByIdSuccess = (log) => {
  return {
    type: actionTypes.FETCH_LOGS_SUPERADMIN_BY_ID_SUCCESS,
    log: log,
  };
};


// OPTIONS FOR FILTER

export const requestLogsSuperadminOptionsTenantsStart = () => {
  return {
    type: actionTypes.REQUEST_LOGS_SUPERADMIN_OPTIONS_TENANTS_START,
  };
};

export const fetchLogsSuperadminOptionsTenantsSuccess = (tenants) => {
  return {
    type: actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_SUCCESS,
    tenants,
  };
};

export const fetchLogsSuperadminOptionsTenantsFail = (error) => {
  return {
    type: actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_TENANTS_FAIL,
    error,
  };
};


export const fetchLogsSuperadminOptionsTenants = (page = 1, limit = 10, search, order = 'asc', orderBy = 'name') => {
  fetchLogsSuperadminOptionsTenants_cancel && fetchLogsSuperadminOptionsTenants_cancel()
  return dispatch => {
    dispatch(requestLogsSuperadminOptionsTenantsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/tenants' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchLogsSuperadminOptionsTenants_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchLogsSuperadminOptionsTenantsSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchLogsSuperadminOptionsTenantsFail(err));
      });
  };
};



export const requestLogsSuperadminOptionsUsersStart = () => {
  return {
    type: actionTypes.REQUEST_LOGS_SUPERADMIN_OPTIONS_USERS_START,
  };
};

export const fetchLogsSuperadminOptionsUsersSuccess = (users) => {
  return {
    type: actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_SUCCESS,
    users,
  };
};

export const fetchLogsSuperadminOptionsUsersFail = (error) => {
  return {
    type: actionTypes.FETCH_LOGS_SUPERADMIN_OPTIONS_USERS_FAIL,
    error,
  };
};


export const fetchLogsSuperadminOptionsUsers = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(requestLogsSuperadminOptionsUsersStart());
    let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;

    API.get('/users/superadmin' + queryParams)
      .then(res => {
        dispatch(fetchLogsSuperadminOptionsUsersSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchLogsSuperadminOptionsUsersFail(err));
      });
  };
};